export enum StorageKeyEnum {
  LEAD = 'lead',
  SERVICE_DRAFT = 'service_draft',
  IN_APP_SHOWN = '@to_parado/in-app-shown',
}
